'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { InternalProvider, useComponentDeprecation } from '../../util';
import { CardElement } from './elements';
import { CardContext } from './CardContext';

/**
 * @deprecated
 */
export const Card = /*#__PURE__*/React.forwardRef(({
  disabled = false,
  maxWidth = 0,
  type = 'default',
  selected = false,
  element = 'div',
  padding,
  disableSvgColorOverride,
  children,
  ariaLabel,
  ...rest
}, fRef) => {
  useComponentDeprecation({
    name: 'Card',
    alternative: 'SimpleCard',
    version: '5'
  });
  const cardElementProps = {
    $maxWidth: maxWidth,
    $disabled: disabled,
    $type: type,
    $selected: selected,
    $padding: padding,
    $element: element,
    $ariaLabel: ariaLabel,
    $disableSvgColorOverride: disableSvgColorOverride,
    ...rest,
    ...(element === 'button' ? {
      disabled
    } : {})
  };
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(CardElement, _extends({
    "data-aui": "card",
    ref: fRef,
    as: element
  }, cardElementProps, {
    "aria-label": selected ? `${ariaLabel && ariaLabel + ', '}` + 'selected' : ariaLabel ? ariaLabel : undefined
  }), /*#__PURE__*/React.createElement(CardContext.Provider, {
    value: {
      isInsideCard: true
    }
  }, children)));
});